/* DillySocks — Quick-Add-Slider (ersetzt Horizons Quick-Add-Modal auf
   Produktkarten).

   Klick auf den runden Beutel-Button einer Karte oeffnet einen von rechts
   einfahrenden Drawer (Optik wie der Warenkorb-Drawer) mit Bildgalerie
   (3:4, Swipe + Punkte), Preis, Trusted-Sternen, Groessen-Buttons,
   produktbezogener Groessentabelle (Overlay) und Trust-Elementen.
   Die Groessenwahl IST die Bestaetigung: kurzer Flash (~260ms), Artikel
   geht in den Warenkorb, Drawer schliesst, Warenkorb-Drawer oeffnet.

   Abgefangen werden "Choose"-Buttons von 1-Options-Produkten ohne
   Selling Plans (= Socken mit Groessen) sowie von 2-Options-Produkten mit
   Mengen-Option (data-ds-qty-option, z. B. Totebag Deal: erst Deal, dann
   Groesse). Direkt-Add-Buttons (1 Variante) und uebrige Mehr-Options-/
   Abo-Produkte behalten Horizons Standard-Verhalten. */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  'use strict';

  var SIZE_GUIDE_URL = '/pages/groessentabellen';
  /* Trusted-Shops-Shopbewertung (statisch; Badge-iframe ist nicht auslesbar) */
  var TRUSTED_RATING = 4.65;

  // Übersetzte Strings aus dem JSON-Block, den layout/theme.liquid rendert
  // (dieses Asset ist ein statisches <script src>, kein {% javascript %}-Tag).
  // Muss VOR SIZE_CHARTS stehen, das I18N.kidsHeader direkt beim Laden nutzt.
  var I18N_EL = document.querySelector('[data-ds-quick-add-i18n]');
  var I18N = I18N_EL ? JSON.parse(I18N_EL.textContent) : {};
  function fmt(str, vars) {
    return (str || '').replace(/\[\[(\w+)\]\]/g, function (_, key) {
      return vars && key in vars ? vars[key] : '';
    });
  }

  /* Groessentabellen wie auf der Live-PDP — gerendert werden nur die
     Zeilen, deren Groesse das Produkt tatsaechlich hat. */
  var SIZE_CHARTS = [
    {
      head: ['EU', 'CM', 'US', 'UK'],
      rows: {
        '36-40': ['23-25', '4.5-7.5', '4-7'],
        '41-46': ['25.5-29', '8-12', '7.5-11.5'],
      },
    },
    {
      head: [I18N.kidsHeader, 'EU', 'CM', 'US'],
      rows: {
        '0-12M': ['15-18', '3-5.5', '8.5-11.5'],
        '12-24M': ['19-22', '6-6.5', '12-14'],
        '2-3Y': ['23-26', '6.5-7.5', '14.5-16.5'],
        '4-6Y': ['27-30', '7.5-8', '17-19'],
        '7-9Y': ['31-34', '8.5-9.5', '19.5-21.5'],
      },
    },
  ];

  var els = null;
  var busy = false;

  /* Waehrung/Format des aktiven Markts (snippets/ds-market.liquid) */
  var MARKET = window.DS_MARKET || {};
  var ROOT = MARKET.root || '';
  function money(cents) {
    if (typeof window.dsMoney === 'function') return window.dsMoney(cents);
    return (cents / 100).toFixed(2) + ' ' + (MARKET.currency || '');
  }

  /* ---- Drawer-Skelett einmalig erzeugen --------------------------------- */
  function ensureEls() {
    if (els) return els;

    /* Scrim/Aside/Kopf/Schliessen/Escape kommen aus der gemeinsamen
       Drawer-Basis (ds-drawer.js); hier nur der Quick-Add-Inhalt. */
    var drawer = window.dsDrawer.create({
      title: I18N.title,
      ariaLabel: I18N.title,
      onClose: closeChart,
    });
    var aside = drawer.aside;
    drawer.body.innerHTML =
      '  <div class="ds-qadd__media">' +
      '    <div class="ds-qadd__track"></div>' +
      '    <span class="ds-qadd__badge" hidden></span>' +
      '    <div class="ds-qadd__dots" hidden></div>' +
      '  </div>' +
      '  <div class="ds-qadd__titlerow">' +
      '    <div class="ds-qadd__name"></div>' +
      '    <div class="ds-qadd__price"></div>' +
      '  </div>' +
      '  <div class="ds-qadd__stars">' +
      '    <span class="ds-pcard-rating__stars" style="--ds-rating-pct: ' + (TRUSTED_RATING / 5) * 100 + '%;" aria-hidden="true"></span>' +
      '    <span class="ds-qadd__stars-val">' + TRUSTED_RATING.toFixed(2).replace('.', ',') + '</span>' +
      '    <span class="ds-qadd__stars-src">Trusted Shops</span>' +
      '  </div>' +
      '  <div class="ds-qadd__dealhead" hidden>' + (I18N.dealHeading || '') + '</div>' +
      '  <div class="ds-qadd__deals" hidden></div>' +
      '  <div class="ds-qadd__sizehead">' +
      '    <span>' + I18N.sizeHeading + '</span>' +
      '    <a href="' + SIZE_GUIDE_URL + '" class="ds-qadd__chartlink">' + I18N.sizeChartLink + '</a>' +
      '  </div>' +
      '  <div class="ds-qadd__sizes"></div>' +
      '  <div class="ds-qadd__hint">' + I18N.hint + '</div>' +
      '  <div class="ds-qadd__trust">' +
      '    <div class="ds-qadd__trustrow ds-qadd__trustrow--avail"><i class="fa-solid fa-circle-check" aria-hidden="true"></i> ' + I18N.availNow + '</div>' +
      '    <div class="ds-qadd__trustrow"><i class="fa-solid fa-truck-fast" aria-hidden="true"></i> ' + I18N.deliveryDays + '</div>' +
      '    <div class="ds-qadd__trustrow"><i class="fa-solid fa-rotate-left" aria-hidden="true"></i> ' + I18N.returnDays + '</div>' +
      '    <div class="ds-qadd__trustrow"><i class="fa-solid fa-leaf" aria-hidden="true"></i> ' + I18N.climateNeutral + '</div>' +
      '  </div>';
    aside.insertAdjacentHTML(
      'beforeend',
      '<div class="ds-qadd__chart" aria-hidden="true">' +
      '  <div class="ds-qadd__head">' +
      '    <h2 class="ds-qadd__title">' + I18N.sizeChartLink + '</h2>' +
      '    <button type="button" class="ds-qadd__close ds-qadd__chart-close" aria-label="' + I18N.close + '"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>' +
      '  </div>' +
      '  <div class="ds-qadd__chart-body">' +
      '    <table class="ds-qadd__chart-table"></table>' +
      '    <a class="ds-qadd__chart-more" href="' + SIZE_GUIDE_URL + '" target="_blank" rel="noopener">' + I18N.moreInfo + '</a>' +
      '  </div>' +
      '</div>'
    );

    aside.querySelector('.ds-qadd__chart-close').addEventListener('click', closeChart);
    /* Escape: zuerst die Groessentabelle schliessen, dann erst den Drawer
       (die Drawer-Basis respektiert defaultPrevented). */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var chart = aside.querySelector('.ds-qadd__chart');
      if (chart.classList.contains('is-open')) { e.preventDefault(); closeChart(); }
    });

    /* Galerie: aktiven Punkt beim Swipen nachfuehren */
    var track = aside.querySelector('.ds-qadd__track');
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      aside.querySelectorAll('.ds-qadd__dot').forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
      });
    }, { passive: true });

    aside.querySelector('.ds-qadd__chartlink').addEventListener('click', function (e) {
      /* Nur abfangen, wenn wir eine produktbezogene Tabelle haben —
         sonst faellt der Link auf die Uebersichtsseite zurueck. */
      if (aside.querySelector('.ds-qadd__chart-table').dataset.hasRows === '1') {
        e.preventDefault();
        openChart();
      }
    });

    els = { scrim: drawer.scrim, aside: aside, drawer: drawer };
    return els;
  }

  function close() {
    if (!els) return;
    closeChart();
    els.drawer.close();
  }

  function show() {
    els.drawer.open();
  }

  function openChart() {
    var c = els.aside.querySelector('.ds-qadd__chart');
    c.classList.add('is-open');
    c.setAttribute('aria-hidden', 'false');
  }
  function closeChart() {
    if (!els) return;
    var c = els.aside.querySelector('.ds-qadd__chart');
    c.classList.remove('is-open');
    c.setAttribute('aria-hidden', 'true');
  }

  /* ---- Produktbezogene Groessentabelle ----------------------------------- */
  function renderChart(titles) {
    var table = els.aside.querySelector('.ds-qadd__chart-table');
    var chart = null;
    for (var i = 0; i < SIZE_CHARTS.length; i++) {
      if (titles.some(function (t) { return SIZE_CHARTS[i].rows[t]; })) { chart = SIZE_CHARTS[i]; break; }
    }
    if (!chart) {
      table.dataset.hasRows = '0';
      return;
    }
    var html = '<tr>' + chart.head.map(function (h, j) {
      return (j === 0 ? '<th>' : '<td>') + h + (j === 0 ? '</th>' : '</td>');
    }).join('') + '</tr>';
    titles.forEach(function (t) {
      var row = chart.rows[t];
      if (!row) return;
      html += '<tr><th>' + t + '</th>' + row.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
    });
    table.innerHTML = html;
    table.dataset.hasRows = '1';
  }

  /* ---- Inhalt fuellen ---------------------------------------------------- */
  function render(p, qtyOptionName) {
    var a = ensureEls().aside;

    /* Bildgalerie: alle Produktbilder, Swipe + Punkte */
    var imgs = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean).slice(0, 6);
    var track = a.querySelector('.ds-qadd__track');
    track.innerHTML = imgs.map(function (src) {
      return '<img src="' + src + '" alt="" loading="lazy">';
    }).join('');
    track.querySelector('img') && (track.querySelector('img').alt = p.title);
    track.scrollLeft = 0;
    var dots = a.querySelector('.ds-qadd__dots');
    if (imgs.length > 1) {
      dots.innerHTML = imgs.map(function (_, i) {
        return '<button type="button" class="ds-qadd__dot' + (i === 0 ? ' is-active' : '') + '" aria-label="' + fmt(I18N.imageAria, { n: i + 1 }) + '"></button>';
      }).join('');
      dots.hidden = false;
      dots.querySelectorAll('.ds-qadd__dot').forEach(function (d, i) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
    } else {
      dots.hidden = true;
      dots.innerHTML = '';
    }

    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var badge = a.querySelector('.ds-qadd__badge');
    if (onSale) {
      badge.textContent = '-' + Math.round((1 - p.price / p.compare_at_price) * 100) + '%';
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }

    a.querySelector('.ds-qadd__name').textContent = p.title;
    a.querySelector('.ds-qadd__price').innerHTML = onSale
      ? '<s>' + money(p.compare_at_price) + '</s> ' + money(p.price)
      : money(p.price);

    var hint = a.querySelector('.ds-qadd__hint');
    hint.textContent = I18N.hint;
    hint.classList.remove('is-error');

    var dealHead = a.querySelector('.ds-qadd__dealhead');
    var deals = a.querySelector('.ds-qadd__deals');
    /* /products/handle.js liefert options als Objekte {name, values} */
    var optionNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var qtyIdx = qtyOptionName ? optionNames.indexOf(qtyOptionName) : -1;

    if (qtyIdx < 0 || optionNames.length !== 2) {
      /* Standard: 1 Option = Groesse, jede Variante eine Pille */
      dealHead.hidden = true;
      deals.hidden = true;
      deals.innerHTML = '';
      renderSizes(p.variants.map(function (v) {
        return { label: v.title, variant: v };
      }));
      renderChart(p.variants.map(function (v) { return v.title; }));
      return;
    }

    /* Mengen-Option (z. B. «5 Paar Socken / 10 / 15») + Groesse:
       Deal-Pillen oben, Groessen-Pillen unten; Groesse antippen = Warenkorb.
       Vorausgewaehlt ist der groesste Deal (gleich wie Standard-Deal der PDP). */
    var sizeIdx = qtyIdx === 0 ? 1 : 0;
    /* Werte in Admin-Reihenfolge (Totebag: 15 · 10 · 5), Fallback aus den Varianten */
    var dealValues = (p.options[qtyIdx] && p.options[qtyIdx].values || []).slice();
    var sizeValues = (p.options[sizeIdx] && p.options[sizeIdx].values || []).slice();
    p.variants.forEach(function (v) {
      if (dealValues.indexOf(v.options[qtyIdx]) < 0) dealValues.push(v.options[qtyIdx]);
      if (sizeValues.indexOf(v.options[sizeIdx]) < 0) sizeValues.push(v.options[sizeIdx]);
    });
    var num = function (s) { return parseInt(String(s).replace(/[^0-9]/g, ''), 10) || 0; };
    var current = dealValues.slice().sort(function (x, y) { return num(y) - num(x); })[0];

    function variantFor(deal, size) {
      return p.variants.filter(function (v) {
        return v.options[qtyIdx] === deal && v.options[sizeIdx] === size;
      })[0];
    }
    function applyDeal(deal) {
      current = deal;
      deals.querySelectorAll('.ds-qadd__deal').forEach(function (b) {
        b.classList.toggle('is-on', b.dataset.deal === deal);
      });
      var priced = sizeValues.map(function (s) { return variantFor(deal, s); })
        .filter(function (v) { return v && v.available; })[0] || variantFor(deal, sizeValues[0]);
      if (priced) {
        var sale = priced.compare_at_price && priced.compare_at_price > priced.price;
        a.querySelector('.ds-qadd__price').innerHTML = sale
          ? '<s>' + money(priced.compare_at_price) + '</s> ' + money(priced.price)
          : money(priced.price);
      }
      renderSizes(sizeValues.map(function (s) {
        return { label: s, variant: variantFor(deal, s) };
      }));
    }

    deals.innerHTML = '';
    dealValues.forEach(function (d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-qadd__deal';
      b.textContent = d;
      b.dataset.deal = d;
      var anyAvailable = sizeValues.some(function (s) { var v = variantFor(d, s); return v && v.available; });
      if (!anyAvailable) b.disabled = true;
      b.addEventListener('click', function () { if (!busy) applyDeal(d); });
      deals.appendChild(b);
    });
    dealHead.hidden = false;
    deals.hidden = false;
    applyDeal(current);
    renderChart(sizeValues);
  }

  /* Groessen-Pillen: {label, variant}; ohne Variante oder ausverkauft = inaktiv */
  function renderSizes(items) {
    var sizes = ensureEls().aside.querySelector('.ds-qadd__sizes');
    sizes.innerHTML = '';
    items.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-qadd__size';
      b.textContent = it.label;
      if (!it.variant || !it.variant.available) {
        b.disabled = true;
        b.classList.add('is-soldout');
      } else {
        b.dataset.variantId = it.variant.id;
        b.addEventListener('click', function () { choose(b); });
      }
      sizes.appendChild(b);
    });
  }

  /* ---- Kern-Interaktion: Groesse antippen = in den Warenkorb ------------- */
  function choose(btn) {
    if (busy) return;
    busy = true;
    btn.classList.add('is-picked');
    btn.innerHTML = '<i class="fa-solid fa-check" aria-hidden="true"></i> ' + btn.textContent;

    setTimeout(function () { addToCart(btn); }, 260);
  }

  async function addToCart(btn) {
    var variantId = btn.dataset.variantId;

    var deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'quick-add',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    }));

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      var ajaxCart = await (await fetch('/cart.js')).json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: { items: ajaxCart.items, itemCount: ajaxCart.item_count, didError: false },
      });
      /* Quick-Add zu, Warenkorb-Drawer explizit oeffnen (das auto-open-
         Attribut ist im Theme deaktiviert, daher reicht das Event nicht) */
      close();
      setTimeout(function () {
        var cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function' && !cartDrawer.hasAttribute('open')) {
          cartDrawer.open();
        }
      }, 180);
    } catch (e) {
      deferred.resolve({ detail: { didError: true } });
      btn.classList.remove('is-picked');
      btn.innerHTML = btn.textContent.replace(/^\s*/, '');
      var hint = els.aside.querySelector('.ds-qadd__hint');
      hint.textContent = I18N.error;
      hint.classList.add('is-error');
    }
    busy = false;
  }

  /* ---- Beutel-Button der Karten uebernehmen ------------------------------
     Horizons on:click-Bindung feuert VOR jedem eigenen Listener (frueher
     registriert) und wuerde das Modal zusaetzlich oeffnen. Bekannter
     Horizon-Quirk: geklonte Knoten verlieren die on:click-Bindung — darum
     ersetzen wir jeden Choose-Button durch einen Klon mit eigenem Handler.
     Ein MutationObserver erfasst nachgeladene Karten (Filter/Pagination). */
  function onChooseClick(e) {
    e.preventDefault();
    var qa = e.currentTarget.closest('quick-add-component');
    var card = qa && qa.closest('.product-card');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var handle = link.pathname.split('/products/')[1].split('/')[0].split('?')[0];
    var qtyOptionName = qa.dataset.dsQtyOption || '';

    ensureEls();
    /* Markt-Praefix: ohne ihn liefert der Endpoint immer CHF-Preise */
    fetch(ROOT + '/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        render(p, qtyOptionName);
        show();
      })
      .catch(function () {
        /* Im Zweifel nicht blockieren: zur Produktseite */
        window.location.href = link.href;
      });
  }

  function hijack() {
    document
      .querySelectorAll(
        'quick-add-component[data-product-options-count="1"]:not([data-uses-selling-plans="true"]) .quick-add__button--choose:not([data-ds-qadd]), ' +
        'quick-add-component[data-product-options-count="2"][data-ds-qty-option]:not([data-uses-selling-plans="true"]) .quick-add__button--choose:not([data-ds-qadd])'
      )
      .forEach(function (btn) {
        var clone = btn.cloneNode(true);
        clone.removeAttribute('on:click');
        clone.setAttribute('data-ds-qadd', '1');
        clone.addEventListener('click', onChooseClick);
        btn.replaceWith(clone);
      });
  }

  /* Quick-Add-Button aus der Galerie in die KARTE verschieben.
     Grund: Die Galerie hat overflow:hidden (rundet das Bild UND kappt die
     min-content-Breite der Slideshow, die sonst den Grid-Track der Karte breiter
     als die Karte macht -> unterschiedliche Bildhoehen je Collection). Der
     Quick-Add-Button sitzt aber optisch UNTER der Galerie (im weissen Kartenteil)
     und wuerde von diesem overflow:hidden weggeschnitten. Als direktes Kind der
     Karte ist er nicht mehr betroffen; seine absolute Position (inset:0 an
     .product-card) bleibt identisch. */
  function relocateQuickAdd() {
    document
      .querySelectorAll('.product-grid .product-card .card-gallery .quick-add:not([data-ds-moved])')
      .forEach(function (qa) {
        var card = qa.closest('.product-card');
        if (!card) return;
        qa.setAttribute('data-ds-moved', '1');
        card.appendChild(qa);
      });
  }

  /* Promo-Kacheln (blocks/ds-promo.liquid): Infinite Scroll haengt die
     Folgeseiten-Kopien derselben Kachel erneut ans Raster — nur das erste
     Exemplar pro Block-ID behalten. */
  function dedupePromos() {
    var seen = {};
    document.querySelectorAll('[data-ds-promo-id]').forEach(function (el) {
      var id = el.dataset.dsPromoId;
      if (seen[id]) el.remove();
      else seen[id] = true;
    });
  }

  var scheduled = false;
  function scheduleHijack() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      relocateQuickAdd();
      hijack();
      dedupePromos();
    });
  }

  relocateQuickAdd();
  hijack();
  new MutationObserver(scheduleHijack).observe(document.body, { childList: true, subtree: true });
})();
